query EntryCountQuery($uri: [String]!, $site: [String]!) {
  entryCount(uri: $uri, site: $site)
}
